import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, Injector, PLATFORM_ID, signal } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { isTokenExpired } from '@sml/utility';
import { map, Observable } from 'rxjs';
 
@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  private readonly _isAuthenticated = signal(false);
  private readonly _isTokenExpired = signal(false);
  private platformId = inject(PLATFORM_ID);
  auth!: AuthService;
  private readonly allowedEmails =
    environment.allowedEmailsForTemplateActions.map((e) =>
      e.trim().toLowerCase()
    );

  constructor(private injector: Injector) {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeAuthService();
    }
  }

  get isAuthenticated() {
    return this._isAuthenticated.asReadonly();
  }

  get isTokenExpired() {
    return this._isTokenExpired.asReadonly();
  }

  // login() {
  //   this.authState.auth.loginWithRedirect();
  // }

  private async initializeAuthService() {
    const { AuthService } = await import('@auth0/auth0-angular');
    const service = this.injector.get(AuthService);
    this.auth = service;
    service.isAuthenticated$.subscribe((isAuth) => {
      this._isAuthenticated.set(isAuth);
    });
    service.idTokenClaims$.subscribe((token) => {
      if (token) {
        const idToken = token?.__raw;
        this._isTokenExpired.set(isTokenExpired(idToken));
      }
    });
  }

  getUserEmail(): Observable<string | null> {
    return this.auth.user$.pipe(map((user) => user?.email?.trim() ?? null));
  }
  public isEmailAllowedForTemplateActions(): Observable<boolean> {
    return this.getUserEmail().pipe(
      map((email) => {
        if (!email) return false;
        const normalizedEmail = email.trim().toLowerCase();
        return this.allowedEmails.includes(normalizedEmail);
      })
    );
  }

  // logout() {
  //   this.authState.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  // }
}